import { PROYECT, api_post, api_put, api_get, api_delete } from "services/api";
import { fetchAccountsByStation } from "./accountingAccountService";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import ACCOUNTING_ACCOUNT_TYPES, { ACCOUNTING_ACCOUNT_LOADINGS } from "redux/reducers/accountingAccount/accountingAccountTypes";

const {
  CREATE_ACCOUNTING_ACCOUNT,
  DELETE_ACCOUNTING_ACCOUNT,
  GET_ACCOUNTING_ACCOUNT_LIST,
  GET_SAT_GROUPING_CODES,
  SET_ACCOUNTING_ACCOUNT_SEARCH_FILTERS,
  UPDATE_ACCOUNTING_ACCOUNT,
} = ACCOUNTING_ACCOUNT_TYPES;

const { GET_LIST, GET_SAT_CODES, CREATE, UPDATE, DELETE } = ACCOUNTING_ACCOUNT_LOADINGS;
const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}`;
const accountingAccountsUrl = `${baseUrl}/accounting_account`;
const getIdUrl = (accountingAccountId) => `${accountingAccountsUrl}/${accountingAccountId}`;

export const setAccountingAccountSearchFilters = (key, value) => ({
  type: SET_ACCOUNTING_ACCOUNT_SEARCH_FILTERS,
  payload: { key, value },
});

export const getAccountingAccountList = (stationId) => async (dispatch, getState) => {
  dispatch(startRequestComp(GET_LIST));
  try {
    const resp = await fetchAccountsByStation(stationId);
    // Si la planta cambió durante la búsqueda, el reducer descarta la respuesta
    // y el aviso de lista vacía ya no aplica.
    const isCurrentStation = getState().accountingAccount.station?.id === stationId;
    if (!resp.length && isCurrentStation) {
      dispatch(setSnackbar("No se encontraron cuentas contables para la planta seleccionada", "warning"));
    }
    dispatch({ type: GET_ACCOUNTING_ACCOUNT_LIST, payload: { stationId, list: resp } });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(GET_LIST));
  }
};

export const createAccountingAccount = (formValues, action = null) => async (dispatch) => {
  dispatch(startRequestComp(CREATE));
  try {
    const resp = await api_post(accountingAccountsUrl, formValues);
    dispatch({
      type: CREATE_ACCOUNTING_ACCOUNT, payload: resp,
    });
    dispatch(setSnackbar("Cuenta contable creada con éxito", "success"));
    if (action) action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(CREATE));
  }
};

export const updateAccountingAccount = (
  accountingAccountId, formValues, action = null,
) => async (dispatch) => {
  const url = getIdUrl(accountingAccountId);
  dispatch(startRequestComp(UPDATE));
  try {
    const resp = await api_put(url, formValues);
    dispatch({
      type: UPDATE_ACCOUNTING_ACCOUNT, payload: resp,
    });
    dispatch(setSnackbar("Cuenta contable actualizada con éxito", "success"));
    if (action) action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(UPDATE));
  }
};

export const deleteAccountingAccount = (accountingAccountId, action = null) => async (dispatch) => {
  const url = getIdUrl(accountingAccountId);
  dispatch(startRequestComp(DELETE));
  try {
    await api_delete(url);
    dispatch({
      type: DELETE_ACCOUNTING_ACCOUNT, payload: accountingAccountId,
    });
    dispatch(setSnackbar("Cuenta contable eliminada con éxito", "success"));
    if (action) action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(DELETE));
  }
};

export const getSatGroupingCodesList = () => async (dispatch) => {
  const url = `${baseUrl}/sat/grouper_codes`;
  dispatch(startRequestComp(GET_SAT_CODES));
  try {
    let resp = await api_get(url);
    if (!Array.isArray(resp)) resp = [];
    if (!resp.length) {
      dispatch(setSnackbar("No se encontraron códigos agrupadores del SAT", "warning"));
    }
    dispatch({ type: GET_SAT_GROUPING_CODES, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(GET_SAT_CODES));
  }
};
